// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 142) return "static/chunks/analytics-9bf3232863111716.js";
	if (chunkId === 482) return "static/chunks/charts-35c3e406854d884c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"359":"e2e313b29639d80b","909":"4a260d5b072ae8d2","944":"cdc4877803f3390d"}[chunkId] + ".js";
};